<template>
  <StakeTooltip
    position="right"
    :label="menuItem.label"
    bg-color="stk-background-color-primary"
  >
    <router-link
      v-if="menuItem.to"
      :class="componentClasses"
      :to="menuItem.disabled ? '#' : menuItem.to"
      :disabled="menuItem.disabled"
    >
      <Icon
        class="sidenav-icon-element"
        :icon="menuItem.icon"
      />
    </router-link>
    <a
      v-else
      class="sidenav-icon"
      :href="menuItem.href"
      :target="menuItem.target"
    >
      <Icon
        class="sidenav-icon-element"
        :icon="menuItem.icon"
      />
    </a>
  </StakeTooltip>
</template>

<script setup>
import { computed } from 'vue';
import { Icon, StakeTooltip } from '@stakeui';

const props = defineProps({
  menuItem: {
    type: Object,
    required: true,
  },
});

const componentClasses = computed(() => [
  'sidenav-icon',
  {
    [`is-${props.menuItem.variant}`]: props.menuItem.variant,
    [`is-disabled`]: props.menuItem.disabled,
  },
]);
</script>

<style>
.sidenav-icon {
  --color: var(--stk-primary);
  color: var(--stk-text-70);
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.5em 0.75em;
  position: relative;
  transition-duration: var(--stk-transition-duration);
  transition-property: opacity;
  justify-content: center;

  &:hover,
  &.router-link-active,
  &.router-link-exact-active {
    .sidenav-link-label {
      color: var(--stk-text-10);
    }

    .sidenav-link-arrow {
      opacity: 1;
      transform: none;
    }
  }

  &.is-disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &.router-link-active,
  &.router-link-exact-active {
    color: var(--stk-primary)
  }

  &.is-valuescore {
    --color: #CF67EF;
  }
}

.sidenav-icon-element {
  color: inherit;
}
</style>
